var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var signupDialog = require('js/lib/notifications/sw-signup-dialog');

$(function() {
  $('body').on('submit', '[data-sw-login-form]', function (e) {
    e.preventDefault();
    var formElement = $(this);
    var data = formElement.serialize();

    var errorElement = $(formElement).find('.text-error');
    var postUrl = $(formElement).attr('action');
    $(formElement).find('.btn-primary').addClass('waiting');

    $.swAjax({
      url: postUrl,
      type: 'POST',
      xhrFields: {withCredentials: true},
      beforeSend: function (xhr) {
        xhr.withCredentials = true;
      },
      data: data,
      dataType: 'json',
      success: function (response) {
        if (response.success === true) {
          $(errorElement).hide();

          var targetUrl = response.targetUrl || $(formElement).find('input[name="targetUrl"]').val();

          if (targetUrl !== '') {
            if (targetUrl.indexOf('#') === 0) {
              window.location.reload();
            }

            if (targetUrl.indexOf('event:') === 0) {
              var doneEvent = targetUrl.replace('event:', '');
              sw.trigger(doneEvent, response);
              signupDialog.hideLoginSignup();
              return;
            }

            window.location.href = '/forward?targetUrl=' + encodeURIComponent(targetUrl);

          } else {
            window.location.reload();
          }

        } else if(response.pageReload === true ) {
          if (!$(formElement).data('sw-recaptcha')) { // reload/redirect only if form has no recaptcha
            var url = window.location.protocol + '//' + window.location.hostname + '/login';
            window.location.replace(url);
          } else {
              $(errorElement).html('Uh oh!  We couldn\'t verify your login credentials.').show();
              $(formElement).find('.btn-primary').removeClass('waiting');
          }
        } else {
          $(errorElement).html('Uh oh!  We couldn\'t verify your login credentials.').show();
          $(formElement).find('.btn-primary').removeClass('waiting');
        }
      }
    });
    return false;
  });
});
